import { fExecuteAPI } from "../../Server/Apis";
import {
  fUnitPriceOnChangeGRV,
  inv04_BUYER_GETROW,
  inv04_fINV04_Attributes_GETROW,
  inv04_fINV04_fDisplay_GETROW,
  inv04_INV04_LoadDetail_GETROW,
  WMSGRV_GRVAttributes_GETROW,
} from "../../Server/ApiV2";
import {
  fAlertToast,
  fcovertToNumber,
  fCalculate_Detail,
  fcheck_null_undefine_replace_empty,
  Get_TransItemStockUOM,
} from "../../Utility/Utilitys";

import {
  Set_GRV_HeadObject_DrCrAccount,
  Set_GRV_HeadObject_Set,
  Set_GRV_HeadObject_A_VocNo,
  Set_GRV_HeadObject_A_PayMode,
  Wms_HeadObject_Buyer_Set,
} from "./SliceGRV";

import {
  vRdxUserInfo,
  vRdxtax,
  GRVRo,
  KernCAConfig,
} from "../../Redux/roStore";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { common_AccountPostingDetail_API } from "../../Server/ApiV2";

// const { tax1, tax2 } = vRdxtax();
// const vRdxUserInfoObj = vRdxUserInfo();
// const { HeadObject } = GRVRo();

export const ErrorMsg = {
  A_VocTyp: "",
  A_VocNo: "",
  A_PostDt: "",
  A_RefNo: "",
  A_RefDt: "",
  A_Type: "",
  A_PayMode: "",
  A_Party: "",
  A_PartyName: "",
  A_Curr: "",
  A_ExRate: "",
  A_Loc: "",
  TaxType: "",
  offer: "",
  A_Buyer: "",
  A_Buyername: "",
  A_CrAc: "",
  A_CrAcName: "",
  A_DrAc: "",
  A_DrAcName: "",
  A_Rounding: "",
  A_DocStat: "",
  A_Taxable: "",
  xErrorMsg: "",
  A_TaxGross: "",
  DO: "",
  CostRecalculate: "",
  BatchType: "",
};
export const ErrorMsgDetail = {
  B_Srno: "",
  B_Itmcd: "",
  B_Barcode: "",
  B_ItmName: "",
  B_Qty: "",
  B_Unit: "",
  B_PackQty: "",
  SplDisc: "",
  B_URateFc: "",
  B_URateLc: "",
  B_GrossAmt: "",
  B_TDiscPerc: "",
  B_TDiscAmt: "",
  B_LDiscPerc: "",
  B_LDiscAmt: "",
  B_FocFlag: "",

  B_FocAmt: "",
  B_ExciseTaxAmt: "",
  B_ExciseTaxNetAmt: "",
  SplDiscAmt: "",
  B_Base_Rate: "",
  B_TaxDept: "",
  B_TaxPerc: "",
  B_TaxAmt: "",
  B_TaxDept2: "",
  B_TaxPerc2: "",
  B_TaxAmt2: "",
  B_NetAddCess: "",
  SplDiscPerc: "",
  B_NetAmt: "",
  B_AprmtFlag: "",
  AddCess: "",

  B_Reason: "",
};
export const vHeaderSearchInit = {
  AnyData: "",
  Name: "",
  Code: "",
};

export const sTrnTyp = "INV04";

const sFocFlagArr = [
  "",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "AA",
  "AB",
  "AC",
  "AD",
  "AE",
  "AF",
  "AG",
  "AH",
  "AJ",
  "AK",
  "AL",
  "AM",
  "AN",
  "AO",
  "AP",
  "AQ",
  "AR",
  "AS",
  "AT",
  "AU",
  "AV",
  "AW",
  "AX",
  "AY",
  "AZ",
  "BA",
  "BB",
  "BC",
  "BD",
  "BE",
  "BF",
  "BG",
  "BH",
  "BJ",
  "BK",
  "BL",
  "BM",
  "BN",
  "BO",
  "BP",
  "BQ",
  "BR",
  "BS",
  "BT",
  "BU",
  "BV",
  "BW",
  "BX",
  "BY",
  "BZ",
  "CA",
  "CB",
  "CC",
  "CD",
  "CE",
  "CF",
  "CG",
  "CH",
  "CJ",
  "CK",
  "CL",
  "CM",
  "CN",
  "CO",
  "CP",
  "CQ",
  "CR",
  "CS",
  "CT",
  "CU",
  "CV",
  "CW",
  "CX",
  "CY",
  "CZ",
  "DA",
  "DB",
  "DC",
  "DD",
  "DE",
  "DF",
  "DG",
  "DH",
  "DJ",
  "DK",
  "DL",
  "DM",
  "DN",
  "DO",
  "DP",
  "DQ",
  "DR",
  "DS",
  "DT",
  "DU",
  "DV",
  "DW",
  "DX",
  "DY",
  "DZ",
];

export const xGC_Toggle_Head_Customer_DropDown_Arr = ["Any", "Code", "Name"];

export const ItemSearchData = [
  "Any",
  "Code",
  "Barcode",
  "Name",
  "RefNo",
  "NameFL",
];

export const locatonSearchData = ["Any", "Code", "Name"];
const sFrom = [
  { Uid: "VENDOR_INV", Name: "Vendor" },
  { Uid: "TRANSFER_RETURN", Name: "Outlet" },
  { Uid: "SALES_RETURN", Name: "Sales Return" },
];

// const sTax = [
//   { Uid: "INTRN001", Name: "VAT" },
//   { Uid: "INTRN002", Name: "Inter.Comp" },
//   { Uid: "INTRN003", Name: "Import" },
// ];

export const sStatusArr = ["ENTER", "POST", "DELETE", "DRAFT", "CANCEL"];

const fKeyGRV = (event) => {
  // GRVContent
  const form = document.getElementById("GRVHead");
  const index = [...form].indexOf(event.target);
  if (index < form.length - 1) {
    if (event.key === "Enter") {
      form.elements[index + 1]?.focus();
    }
  }
};

const fKeyGRVContent = (event) => {
  // GRVContent
  const form = document.getElementById("GRVContent");
  const index = [...form].indexOf(event.target);
  if (index < form.length - 1) {
    if (event.key === "Enter") {
      form.elements[index + 1]?.focus();
    }
  }
};

const fValidationHead_Client = (
  vRdxHead,
  setErrorMsg,
  sFooterObj,
  vMediaQuery,
  fSummary
) => {
  let iRes = true;
  // let xObjHasNullOrUndefinevale =
  //   fCheck_Value_Null_Or_Undefined_ShowAlert(vRdxHead);
  // fAlertToast("WARNING", xObjHasNullOrUndefinevale);
  if (
    vRdxHead.A_VocTyp === "" ||
    vRdxHead.A_VocTyp === null ||
    vRdxHead.A_VocTyp === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_VocTyp: "VocTyp should not be empty",
    }));
    fAlertToast("INFO", "VocTyp should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_VocNo === "" ||
    vRdxHead.A_VocNo === null ||
    vRdxHead.A_VocNo === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, A_VocNo: "VocNo should not be empty" }));
    fAlertToast("INFO", "VocNo should not be empty");
    iRes = false;
  }

  // default format so no need to check format
  if (
    vRdxHead.A_PostDt === "" ||
    vRdxHead.A_PostDt === null ||
    vRdxHead.A_PostDt === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_PostDt: "PostDt should not be empty",
    }));
    fAlertToast("INFO", "PostDt should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_RefNo == "" ||
    vRdxHead.A_RefNo === null ||
    vRdxHead.A_RefNo === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, A_RefNo: "RefNo should not be empty" }));
    fAlertToast("INFO", "RefNo should not be empty");
    iRes = false;
  } else if (vRdxHead.A_RefNo.toUpperCase() === "POS") {
    setErrorMsg((obj) => ({ ...obj, A_RefNo: "RefNo should not be POS" }));
    fAlertToast("INFO", "RefNo should not be POS");

    iRes = false;
  } else if (vRdxHead.A_RefNo.toUpperCase() === "CREDIT") {
    setErrorMsg((obj) => ({ ...obj, A_RefNo: "RefNo should not be CREDIT" }));
    fAlertToast("INFO", "RefNo should not be CREDIT");
    iRes = false;
  }

  if (
    vRdxHead.A_RefDt === "" ||
    vRdxHead.A_RefDt === null ||
    vRdxHead.A_RefDt === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_RefDt: "Reference Date should not be Empty",
    }));
    fAlertToast("INFO", "Reference Date should not be Empty");
    iRes = false;
  }

  // if (
  //   vRdxHead.A_Type === "" ||
  //   vRdxHead.A_Type === null ||
  //   vRdxHead.A_Type === undefined
  // ) {
  //   setErrorMsg((obj) => ({
  //     ...obj,
  //     A_Type: "GRN Type should not be empty",
  //   }));
  //   fAlertToast("INFO", "GRN Type should not be empty" );
  //   iRes = false;
  // }

  if (
    vRdxHead.A_Loc === "" ||
    vRdxHead.A_Loc === null ||
    vRdxHead.A_Loc === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, A_Loc: "Location should not be Empty" }));
    fAlertToast("INFO", "Location should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.A_Buyer === "" ||
    vRdxHead.A_Buyer === null ||
    vRdxHead.A_Buyer === undefined
  ) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({ ...obj, A_Buyer: "Buyer should not be Empty" }));
    fAlertToast("INFO", "Buyer should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.A_PayMode === "" ||
    vRdxHead.A_PayMode === null ||
    vRdxHead.A_PayMode === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_PayMode: "PayMode should not be Empty",
    }));
    fAlertToast("INFO", "PayMode should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.A_Party === "" ||
    vRdxHead.A_Party === null ||
    vRdxHead.A_Party === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_PartyName: "Party should not be empty",
    }));
    fAlertToast("INFO", "Party should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_PartyName === "" ||
    vRdxHead.A_PartyName === null ||
    vRdxHead.A_PartyName === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_PartyName: "Party Name should not be empty",
    }));
    fAlertToast("INFO", "Party Name should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_Curr === "" ||
    vRdxHead.A_Curr === null ||
    vRdxHead.A_Curr === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, A_Curr: "Curr should not be empty" }));
    fAlertToast("INFO", "Curr should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_ExRate === "" ||
    Number(vRdxHead.A_ExRate) === 0 ||
    vRdxHead.A_ExRate === null ||
    vRdxHead.A_ExRate === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_ExRate: "ExRate should not be empty",
    }));
    fAlertToast("INFO", "ExRate should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.TaxType === "" ||
    vRdxHead.TaxType === null ||
    vRdxHead.TaxType === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      TaxType: "Tax Type should not be Empty",
    }));
    fAlertToast("INFO", "Tax Type should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.offer === "" ||
    vRdxHead.offer === null ||
    vRdxHead.offer === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      offer: "Offer should not be Empty",
    }));
    fAlertToast("INFO", "Offer should not be Empty");
    iRes = false;
  }

  if (vRdxHead.DO === "" || vRdxHead.DO === null || vRdxHead.DO === undefined) {
    setErrorMsg((obj) => ({ ...obj, DO: "DO should not be Empty" }));
    fAlertToast("INFO", "DO should not be Empty");
    iRes = false;
  }
  if (
    vRdxHead.A_TaxGross === "" ||
    vRdxHead.A_TaxGross === null ||
    vRdxHead.A_TaxGross === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_TaxGross: "TaxGross should not be Empty",
    }));
    fAlertToast("INFO", "TaxGross should not be Empty");
    iRes = false;
  }
  if (
    vRdxHead.CostRecalculate === "" ||
    vRdxHead.CostRecalculate === null ||
    vRdxHead.CostRecalculate === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      CostRecalculate: "Cost Recalculate should not be Empty",
    }));
    fAlertToast("INFO", "Cost Recalculate should not be Empty");
    iRes = false;
  }

  if (sFooterObj.A_LandVal < 0) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({
      ...obj,
      A_Rounding: "Transaction amount should be greate then zero",
    }));
    fAlertToast("INFO", "Transaction amount should be greate then zero");
    iRes = false;
  }

  // if (vRdxHead.A_DiscPerc === "") {
  //   setCommonError("Discount percentage should not be empty");
  //   setErrorMsg((obj) => ({
  //     ...obj,
  //     A_DiscPerc: "Discount percentage should not be empty",
  //   }));
  //   fAlertToast("INFO", "Discount percentage should not be empty" );
  // iRes = false;
  // } else if (
  //   Number(vRdxHead.A_DiscPerc) !== 0 &&
  //   Number(sFooterObj.A_TDiscAmt) === 0
  // ) {
  //   setCommonError("Check discount percentage2");
  //   setErrorMsg((obj) => ({
  //     ...obj,
  //     A_TDiscAmt: "Check discount percentage2",
  //   }));
  //   fAlertToast("INFO", "Check discount percentage2" );
  // iRes = false;
  // } else if (vRdxHead.A_DiscPerc == 0 && sFooterObj.A_TDiscAmt != 0) {
  //   setCommonError("Check discount percentage1");
  //   setErrorMsg((obj) => ({
  //     ...obj,
  //     A_DiscPerc: "Check discount percentage1",
  //   }));
  //   fAlertToast("INFO", "Check discount percentage1" );
  // iRes = false;
  // }

  return iRes;
};

export const UnitRateFlag = () => {
  const { DBKernObj } = KernCAConfig();
  const iShowField = DBKernObj.WMINV03_UNITRATE_VLDT?.Val === "N";
  if (iShowField) {
    return false;
  } else {
    return true;
  }
};
const fValidationDetail_Client = (
  vRdxHead,
  sBufferObj,
  setErrorMsgDetail,
  sDetailGridData
) => {
  let iRes = true;
  // let xObjHasNullOrUndefinevale =
  //   fCheck_Value_Null_Or_Undefined_ShowAlert(sBufferObj);
  // fAlertToast("WARNING", xObjHasNullOrUndefinevale);
  if (sBufferObj.B_Srno === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Srno: "Serial number should not be empty",
    }));
    fAlertToast("INFO", "Serial number should not be empty");
    iRes = false;
  }

  if (sBufferObj.B_Itmcd === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Itmcd: "Item code should not be empty",
    }));
    fAlertToast("INFO", "Item code should not be empty");
    iRes = false;
  }

  if (sBufferObj.B_ItmName === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_ItmName: "Item name should not be empty",
    }));
    fAlertToast("INFO", "Item name should not be empty");
    iRes = false;
  }

  if (sBufferObj.B_Qty === "" || Number(sBufferObj.B_Qty) <= 0) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Qty: "Qty should not be zero",
    }));
    fAlertToast("INFO", "Qty should not be zero");
    iRes = false;
  }

  if (sBufferObj.B_Unit === "") {
    setErrorMsgDetail((obj) => ({ ...obj, B_Unit: "Select unit" }));
    fAlertToast("INFO", "Select unit");
    iRes = false;
  } else if (
    sBufferObj.B_PackQty === "" ||
    Number(sBufferObj.B_PackQty) === 0
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Unit: "Pack quantity should not be zero",
    }));
    fAlertToast("INFO", "Pack quantity should not be zero");
    iRes = false;
  }
  if (
    sBufferObj.B_Reason === "" ||
    sBufferObj.B_Reason === null ||
    sBufferObj.B_Reason === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Reason: "Reason should not be empty",
    }));
    fAlertToast("INFO", "Reason should not be empty");
    iRes = false;
  }

  if (UnitRateFlag()) {
    if (Number(sBufferObj.B_URateFc) === 0 || sBufferObj.B_URateFc === "") {
      fAlertToast("INFO", "Unit rate[F.C] should not be Zero");
      iRes = false;
    }

    if (Number(sBufferObj.B_URateLc) === 0 || sBufferObj.B_URateLc === "") {
      fAlertToast("INFO", "Unit rate[L.C] should not be  Zero");
      iRes = false;
    }

    if (sBufferObj.B_GrossAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_GrossAmt: "GrossAmt should not be Empty",
      }));
      fAlertToast("INFO", "GrossAmt should not be Empty");
      iRes = false;
    }

    if (sBufferObj.B_TDiscPerc === "" || sBufferObj.B_TDiscAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_TDiscPerc: "TDiscPerc should not be Empty",
      }));
      fAlertToast("INFO", "TDiscPerc should not be Empty");
      iRes = false;
    }

    if (sBufferObj.B_LDiscPerc === "" || sBufferObj.B_LDiscAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_LDiscPerc: "Line discount.% should not be empty",
      }));
      fAlertToast("INFO", "Line discount.% should not be empty");
      iRes = false;
    }

    if (
      (Number(sBufferObj.B_LDiscPerc) === 0 &&
        Number(sBufferObj.B_LDiscAmt) !== 0) ||
      (Number(sBufferObj.B_LDiscPerc) !== 0 &&
        Number(sBufferObj.B_LDiscAmt) === 0)
    ) {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_LDiscPerc: "Line Disc.% or amount should be  Zero",
      }));
      fAlertToast("INFO", "Line Disc.% or amount should be  Zero");
    } else if (
      Number(sBufferObj.B_LDiscPerc) > 100 ||
      Number(sBufferObj.B_LDiscPerc) < 0
    ) {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_LDiscPerc:
          "DiscPerc Percentage must be greater than 0 and less than or equal to 100",
      }));
      fAlertToast(
        "INFO",
        "DiscPerc Percentage must be greater than 0 and less than or equal to 100"
      );
      iRes = false;
    }

    if (sBufferObj.B_FocAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_FocAmt: "FocAmt should not be Empty",
      }));
      fAlertToast("INFO", "FocAmt should not be Empty");
      iRes = false;
    }

    if (sBufferObj.B_FocFlag === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_FocFlag: "FOC  should not be Empty",
      }));
      fAlertToast("INFO", "FOC  should not be Empty");
      iRes = false;
    }

    if (sBufferObj.B_ExciseTaxAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_ExciseTaxAmt: "ExciseTaxAmt should not be Empty",
      }));
      fAlertToast("INFO", "ExciseTaxAmt should not be Empty");
      iRes = false;
    }

    if (sBufferObj.B_ExciseTaxNetAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_ExciseTaxNetAmt: "ExciseTaxNetAmt should not be Empty",
      }));
      fAlertToast("INFO", "ExciseTaxNetAmt should not be Empty");
      iRes = false;
    }

    if (sBufferObj.SplDisc === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        SplDisc: "SplDiscAmt should not be Empty",
      }));
      fAlertToast("INFO", "SplDiscAmt should not be Empty");
      iRes = false;
    }

    if (sBufferObj.B_TaxDept === "") {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxDept: "TaxDept is Empty" }));
      fAlertToast("INFO", "TaxDept is Empty");
      iRes = false;
    }

    if (sBufferObj.B_TaxPerc === "") {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxPerc: "TaxPerc is Empty" }));
      fAlertToast("INFO", "TaxPerc is Empty");
      iRes = false;
    }

    if (sBufferObj.B_TaxAmt === "") {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxAmt: "TaxAmt is Empty" }));
      fAlertToast("INFO", "TaxAmt is Empty");
      iRes = false;
    }

    if (sBufferObj.B_TaxDept2 === "") {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxDept2: "TaxDept2 is Empty" }));
      fAlertToast("INFO", "TaxDept2 is Empty");
      iRes = false;
    }

    if (sBufferObj.B_TaxPerc2 === "") {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxPerc2: "TaxPerc2 is Empty" }));
      fAlertToast("INFO", "TaxPerc2 is Empty");
      iRes = false;
    }

    if (sBufferObj.B_TaxAmt2 === "") {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxAmt2: "TaxAmt2 is Empty" }));
      fAlertToast("INFO", "TaxAmt2 is Empty");
      iRes = false;
    }

    if (sBufferObj.B_NetAddCess === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_NetAddCess: "B_NetAddCess is Empty",
      }));
      fAlertToast("INFO", "NetAddCess is Empty");
      iRes = false;
    }

    if (sBufferObj.SplDiscPerc === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        SplDiscPerc: "SplDiscPerc is Empty",
      }));
      fAlertToast("INFO", "SplDiscPerc is Empty");
      iRes = false;
    }

    if (sBufferObj.B_NetAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_NetAmt: "NetAmt is Empty",
      }));
      fAlertToast("INFO", "NetAmt is Empty");
      iRes = false;
    }
  }

  return iRes;
};

//GCItemSearch
const GetItemSearch = async (
  xValue,
  xVendor,
  setGridSelectRowData,
  setGridSelectRowArr
) => {
  //openCustomer to call api on open modal if value in any data

  let sItemSearch = {
    v_AnyData: xValue,
    v_ItmCd: "",
    v_ItmName: "",
    v_Barcode: "",
    v_ModelSelectedValue: "",
    v_RefNo1: "",
    v_NameFc: "",
    v_CostPr: "",
    v_RSP: "",
    v_Catalogue: "",
    v_Br: "",
    v_RefNo3: "",
    v_Loc: "",
    v_Vendor: xVendor,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(sItemSearch);
  const vItemSearch = await fExecuteAPI("GRN_ITEMSEARCH_GETROW", FinalObj);
  if (vItemSearch.Status === 200) {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setGridSelectRowArr(vItemSearchArr);
    setGridSelectRowData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.Type.response.data.message
        ? vItemSearch.Type.response.data.message
        : "Error in ItemSearch"
    );
    return [];
  }
};

//TODO FULLSEARCH ,UNITARR ,AND CALCULATION
const fItemCodeDependency = async (
  vItemSearchFull,
  vRdxWmsHead,
  sBufferObj,
  setBufferObj,
  setUnit,
  sDefZeroTaxCode,
  sDefZeroCessCode,
  setTransItemStockObj,
  sTax
) => {
  const { HeadObject } = GRVRo();
  const { tax1, tax2 } = vRdxtax();
  if (vItemSearchFull.length > 0) {
    let iTax =
      HeadObject.TaxType == "INTRN003" || HeadObject.TaxType == "INTRN002"
        ? sDefZeroTaxCode
        : vItemSearchFull[0].TaxDept;

    let iCess =
      HeadObject.TaxType == "INTRN003" || HeadObject.TaxType == "INTRN002"
        ? sDefZeroCessCode
        : vItemSearchFull[0].TaxDept2;
    // let iTax =  vItemSearchFull[0].TaxDept;

    // let iCess =  vItemSearchFull[0].TaxDept2;

    let vRdxGRNtax1arr = tax1?.find((obj) => {
      return obj.UId === iTax;
    });

    let vRdxGRNtax2arr = tax2?.find((obj) => {
      return obj.UId === iCess;
    });

    setBufferObj((obj) => ({
      ...obj,
      B_Itmcd: vItemSearchFull[0].ItmCd,
      B_ItmName: vItemSearchFull[0].Name2,
      B_Barcode: vItemSearchFull[0].BarCode,
      B_TaxDept: vRdxGRNtax1arr?.UId,
      B_TaxDept2: vRdxGRNtax2arr?.UId,
      B_TaxPerc: vRdxGRNtax1arr?.Perc,
      B_TaxPerc2: vRdxGRNtax2arr?.Perc,
    }));

    let currentUnitArr = await GetUnitArr(vItemSearchFull[0].ItmCd, setUnit);

    let iUnit = vItemSearchFull[0]?.DefUnit || "";

    if (!iUnit) {
      iUnit = vItemSearchFull[0]?.PurUOM || "";
    }

    let vItemUnitSet = currentUnitArr.find((obj) => {
      return obj.Unit === iUnit;
    });

    if (!vItemUnitSet) {
      iUnit = currentUnitArr[0]?.Unit || "";

      vItemUnitSet = currentUnitArr.find((obj) => {
        return obj.Unit === iUnit;
      });
    }
    await Unit_Onchange_001(
      vItemUnitSet?.Unit,
      vItemUnitSet,
      vItemSearchFull[0]?.ItmCd,
      vRdxGRNtax1arr?.Perc,
      vRdxGRNtax2arr?.Perc,
      sBufferObj,
    setBufferObj,
    setTransItemStockObj
    );
    document.getElementsByName("B_Qty")[0]?.focus();
  } else {
    fAlertToast("FAILED", "Error in Exact Search");
  }
};

const Unit_Onchange_001 = async (
  xUnit = "",
  xUnitObj = {},
  xItemCode = sBufferObj.B_Itmcd,
  iTax1Perc = sBufferObj.B_TaxPerc,
  iTax2Perc = sBufferObj.B_TaxPerc2,
  sBufferObj,
  setBufferObj = () => {},
  setTransItemStockObj = () => {}
) => {
  let currentPackQty = "";
  //by sir
  const { HeadObject } = GRVRo();
  if (!!xUnitObj) {
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: xUnitObj.Unit,
      B_UnitName: xUnitObj.Name1,
      B_PackQty: xUnitObj.PackQty,
    }));
    currentPackQty = xUnitObj?.PackQty;
  }

  let resp = await GetUnitRate(
    xItemCode,
    xUnit,
    HeadObject?.A_Party,
    HeadObject?.A_Loc,
    "", //vRdxWmsHead?.A_RefDocTyp,
    "" //vRdxWmsHead?.A_RefDocNo
  );
  let currentUnitRateObj = {
    B_URateFc: 0,
    B_LDiscPerc: 0,
    AddCess: 0, //addcess
    SplDisc: 0,
    B_ExciseTaxAmt: 0,
  };

  if (resp?.LastPriceDetails.length > 0) {
    currentUnitRateObj = {
      B_URateFc: resp?.LastPriceDetails[0].CostLc,
      B_LDiscPerc: resp?.LastPriceDetails[0].DiscPerc,
      AddCess: resp?.LastPriceDetails[0].AddiCess,
      SplDisc: resp?.LastPriceDetails[0].SplDiscAmt,
      B_ExciseTaxAmt: resp?.LastPriceDetails[0].ExciseAmt,
    };
    setBufferObj((obj) => ({
      ...obj,
      B_URateFc: resp?.LastPriceDetails[0].CostLc,
      B_LDiscPerc: resp?.LastPriceDetails[0].DiscPerc,
      AddCess: resp?.LastPriceDetails[0].AddiCess,
      SplDisc: resp?.LastPriceDetails[0].SplDiscAmt,
      B_ExciseTaxAmt: resp?.LastPriceDetails[0].ExciseAmt,
    }));
  } else {
    setBufferObj((obj) => ({
      ...obj,
      B_URateFc: 0,
      B_LDiscPerc: 0,
      AddCess: 0,
      SplDisc: 0,
      B_ExciseTaxAmt: 0,
    }));
  }

  if (resp?.UnitChangeDetails.length > 0) {
    setTransItemStockObj({
      RPStock: resp?.UnitChangeDetails[0].Stock,
      MSP: resp?.UnitChangeDetails[0].MSP,
      CostPr: resp?.UnitChangeDetails[0].CostPr,
      LPRate: resp?.UnitChangeDetails[0].LpRate,
    });
  } else {
    setTransItemStockObj({
      RPStock: 0,
      MSP: 0,
      CostPr: 0,
      LPRate: 0,
    });
  }

  let {
    B_BaseQty,
    B_URateLc,
    B_GrossAmt,
    B_LDiscAmt,
    B_TDiscAmt,
    B_FocAmt,
    B_ExciseTaxNetAmt,
    B_NetAmt,
    B_TaxAmt,
    B_TaxAmt2,
    B_Rounding,
    B_NetAddCess,
    B_LandVal,
  } = fCalculate_Detail(
    sBufferObj.B_Qty,
    currentPackQty,
    HeadObject.A_ExRate,
    currentUnitRateObj.B_URateFc,
    currentUnitRateObj.B_LDiscPerc,
    sBufferObj.B_TDiscPerc,
    sBufferObj.B_FocFlag,
    currentUnitRateObj.B_ExciseTaxAmt,
    iTax1Perc,
    iTax2Perc,
    currentUnitRateObj.AddCess,
    0
  );

  setBufferObj((obj) => ({
    ...obj,
    B_BaseQty,
    B_URateLc,
    B_GrossAmt,
    B_LDiscAmt,
    B_TDiscAmt,
    B_FocAmt,
    B_ExciseTaxNetAmt,
    B_NetAmt,
    B_TaxAmt,
    B_TaxAmt2,
    B_Rounding,
    B_NetAddCess,
    B_LandVal,
  }));
};

const GetSearchItem = async (xData, xType, xA_Loc, setSearchGridData) => {
  const { HeadObject } = GRVRo();

  let vSeatchVendor = {
    Data: xData,
    Type: xType,
    Loc: xA_Loc,
    v_Vendor: HeadObject.A_Party || "",
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSeatchVendor);
  const vItemSearch = await fExecuteAPI("SEARCHITEM001_GETROW", FinalObj);
  if (vItemSearch.Type == "SUCCESS") {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setSearchGridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.response.data.message
        ? vItemSearch.response.data.message
        : "Error in SearchItem"
    );
  }
};

const fLoad_Grid = async (
  xB_VocNo,
  xB_Srno,
  xRoundingValue = "",
  setDetailGridData,
  setFooterObj,
  xVocTyp
) => {
  const iSIDetail = await GetSIDetail(xB_VocNo, xB_Srno, xVocTyp);

  if (!!iSIDetail?.length && iSIDetail?.length > 0) {
    let GridID = iSIDetail?.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setDetailGridData(GridID);
    var iGrossAmt = 0,
      iTDiscAmt = 0,
      iLDiscAmt = 0,
      iFocAmt = 0,
      iExciseTaxNetAmt = 0,
      iTaxAmt = 0,
      iTaxAmt2 = 0,
      iAddCess = 0,
      iSplDiscAmt1 = 0;

    for (let i = 0; i < iSIDetail?.length; i++) {
      iGrossAmt += iSIDetail[i]?.B_GrossAmt;
      iTDiscAmt += iSIDetail[i]?.B_TDiscAmt;
      iLDiscAmt += iSIDetail[i]?.B_LDiscAmt;
      iFocAmt += iSIDetail[i].B_FocAmt;
      iExciseTaxNetAmt += iSIDetail[i]?.B_ExciseTaxNetAmt;
      iTaxAmt += iSIDetail[i]?.B_TaxAmt;
      iTaxAmt2 += iSIDetail[i]?.B_TaxAmt2;
      iAddCess += iSIDetail[i]?.B_Ad_NetCessAmt;
      iSplDiscAmt1 += iSIDetail[i]?.SplDiscAmt1;
    }

    let iLandVal =
      iGrossAmt -
      iTDiscAmt -
      iLDiscAmt -
      iFocAmt +
      iExciseTaxNetAmt +
      // iTaxAmt +
      // iTaxAmt2 +
      // iAddCess +
      // iSplDiscAmt1 +
      fcovertToNumber(xRoundingValue);
    let netAmtFinal =
      iGrossAmt -
      iTDiscAmt -
      iLDiscAmt -
      iFocAmt +
      iExciseTaxNetAmt +
      iTaxAmt +
      iTaxAmt2 +
      iAddCess +
      // iSplDiscAmt1 +
      fcovertToNumber(xRoundingValue);
    setFooterObj((obj) => ({
      ...obj,
      A_GrossAmt: iGrossAmt.toFixed(2),
      A_TDiscAmt: iTDiscAmt.toFixed(2),
      A_LDiscAmt: iLDiscAmt.toFixed(2),
      A_FocAmt: iFocAmt.toFixed(2),
      A_NetExcise: iExciseTaxNetAmt.toFixed(2),
      A_Tax: iTaxAmt.toFixed(2),
      A_Tax2: iTaxAmt2.toFixed(2),
      A_AddCess: iAddCess.toFixed(2),
      netAmtFinal: netAmtFinal.toFixed(2),
      A_LandVal: iLandVal.toFixed(2),
      A_SplDiscAmt1: iSplDiscAmt1.toFixed(2),
    }));
  } else {
    setDetailGridData([]);
    setFooterObj((obj) => ({
      ...obj,
      A_GrossAmt: 0,
      A_TDiscAmt: 0,
      A_LDiscAmt: 0,
      A_FocAmt: 0,
      A_NetExcise: 0,
      A_Tax: 0,
      A_Tax2: 0,
      A_AddCess: 0,
      A_LandVal: 0,
      A_SplDiscAmt1: 0,
      netAmtFinal: 0,
    }));
  }
};

//Reverse Modal
const fCloseReverseTransactionModal = (setReverseTransactionModal) => {
  setReverseTransactionModal(false);
};

const fOpenReverseTransactionModal = (setReverseTransactionModal) => {
  setReverseTransactionModal(true);
};

const fReverse = (fSave, setRevNarr, setReverseTransactionModal) => {
  fCloseReverseTransactionModal(setReverseTransactionModal);
  confirmAlert({
    title: "Reverse",
    message: "Are you sure to Reverse.",
    buttons: [
      {
        className: "alertBtn",
        label: "Yes",
        onClick: () => fSave(),
      },
      {
        className: "alertBtn",
        label: "No",
        onClick: () => setRevNarr(""),
      },
    ],
  });
};

const fDefaultPayload = (xPaymode, dispatch) => {
  let iPaymode = xPaymode == "BOTH" ? "CREDIT" : xPaymode; //by client
  let DefaultPayload = {
    currentPayMode: iPaymode,
    PaymodeEnable: false,
  };
  if (xPaymode == "BOTH") {
    DefaultPayload.PaymodeEnable = false;
  } else {
    DefaultPayload.PaymodeEnable = true;
  }

  dispatch(
    Set_GRV_HeadObject_A_PayMode({
      A_PayMode: iPaymode,
    })
  );
  return DefaultPayload;
};

//HEAD LOADING API
// Api

// Checkbox_Rights_GETROW
const GetCheckboxUserRights = async (dispatch) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const vCheckBoxRightsObj = {
    usercd: vRdxUserInfoObj.UserID,
    usergrp: vRdxUserInfoObj.UserGroupCode,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vCheckBoxRightsObj);
  const vCheckBoxRights = await fExecuteAPI(
    "Checkbox_User_Rights_GETROW",
    FinalObj
  );
  if (vCheckBoxRights?.Type?.toUpperCase() === "SUCCESS") {
    return vCheckBoxRights?.ResultSet;
  } else {
    fAlertToast(
      "FAILED",
      vCheckBoxRights?.response?.data?.message
        ? vCheckBoxRights?.response?.data?.message
        : "Error in CheckBoxRights"
    );
    return [];
  }
};

//GET_API_Buyer
const GetBuyer = async (xBr, xvocTyp, xvocNo, dispatch) => {
  let iBuyerObj = {
    v_Br: xBr,
    v_TrnTyp: sTrnTyp,
    v_VocTyp: xvocTyp,
    v_VocNo: xvocNo,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(iBuyerObj);
  const resp = await inv04_BUYER_GETROW(FinalObj);

  if (resp?.status === 200) {
    return resp?.data?.ResultSet.length > 0 ? resp?.data?.ResultSet : [];
  } else {
    return [];
  }
};
//SALESMAN_GETROW
const GetSalesman = async (dispatch) => {
  const iSalesman = await fExecuteAPI("SALESMAN_GETROW");
  if (iSalesman?.Type?.toUpperCase() === "SUCCESS") {
    return iSalesman.ResultSet.length > 0 ? iSalesman.ResultSet : [];
  } else {
    fAlertToast(
      "FAILED",
      iSalesman.response.data.Status
        ? iSalesman.response.data.Status
        : "Error in Currency"
    );
    return [];
  }
};

//API DEFAULTDRCRACCOUNT_GETROW
const GetDefaultDrCrAccount = async (xVocTyp, xPayMode, xParty, dispatch) => {
  const { HeadObject } = GRVRo();
  let vDefaultDrCrAccountObj = {
    process: sTrnTyp,
    voucher: xVocTyp,
    paymode: xPayMode,
    party: xParty,
    Type: HeadObject.A_Type,
    Loc: HeadObject.A_Loc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vDefaultDrCrAccountObj);
  const vDefaultDrCrAccount = await fExecuteAPI(
    "DEFAULTDRCRACCOUNT_GETROW",
    FinalObj
  );
  if (vDefaultDrCrAccount?.Type?.toUpperCase() === "SUCCESS") {
    if (vDefaultDrCrAccount?.ResultSet?.length > 0) {
      dispatch(
        Set_GRV_HeadObject_DrCrAccount({
          A_CrAc: !!vDefaultDrCrAccount.ResultSet[0]?.CrAc
            ? vDefaultDrCrAccount.ResultSet[0]?.CrAc
            : "",
          A_CrAcName: !!vDefaultDrCrAccount.ResultSet[0]?.CrAcName
            ? vDefaultDrCrAccount.ResultSet[0]?.CrAcName
            : "",
          A_DrAc: vDefaultDrCrAccount.ResultSet[0]?.DrAc,
          A_DrAcName: vDefaultDrCrAccount.ResultSet[0]?.DrAcName,
        })
      );
    }
  } else {
    fAlertToast("FAILED", vDefaultDrCrAccount.Message);
  }
};

//API SALESHISTORY_GETROW
const GetSalesHistory = async (
  xItmcd,
  xUnit,
  xParty,
  xLoc,
  setGridSalesHistoryRowData
) => {
  let vSalesHistoryObj = {
    itmCd: xItmcd,
    party: xParty,
    unit: xUnit,
    loc: xLoc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSalesHistoryObj);

  const vSalesHistory = await fExecuteAPI(
    "WMINV04_salesHistory_GETROW",
    FinalObj
  );
  if (vSalesHistory?.Type?.toUpperCase() === "SUCCESS") {
    let vSalesHistoryResp = vSalesHistory.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
      // A_PostDt: moment(obj.A_PostDt).format("DD/MM/YYYY"),
    }));
    setGridSalesHistoryRowData(vSalesHistoryResp);
    return vSalesHistory.ResultSet.length > 0 ? vSalesHistoryResp : [];
  } else {
    fAlertToast("FAILED", vSalesHistory.Message);
    return [];
  }
};

//API GRN_LOCATIONSEARCH_GETROW
const GetLocation = async (
  xAnyData,
  xCode,
  xName,
  UserID,
  setHeaderSearchResultArr,
  setHeaderSearchResultData
) => {
  let vHeaderSearchObj = {
    v_AnyData: xAnyData,
    v_Cd: xCode,
    v_Distri: "Y",
    v_Name: xName,
    v_UserCd: UserID,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vHeaderSearchObj);

  const vHeaderSearch = await fExecuteAPI(
    "GRN_LOCATIONSEARCH_GETROW",
    FinalObj
  );
  if (vHeaderSearch.Status === 200) {
    let GridID = vHeaderSearch.ResultSet?.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setHeaderSearchResultArr(GridID);
    setHeaderSearchResultData(GridID);
    return GridID;
  } else {
    fAlertToast(
      "FAILED",
      vHeaderSearch.response.data.Status
        ? vHeaderSearch.response.data.Status
        : "Error in loading SrcDoc"
    );
    return [];
  }
};

//API Unit GETITEMUNITSINBOUND_GETROW
const GetUnitArr = async (xItemCode, setUnit, loaderScreen = true) => {
  let itemUnitobj = {
    itemCd: xItemCode,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(itemUnitobj);

  const UnitInfo = await fExecuteAPI(
    "GETITEMUNITSINBOUND_GETROW",
    FinalObj,
    loaderScreen
  );
  if (UnitInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitInfo.ResultSet.length > 0) {
      setUnit(UnitInfo.ResultSet);
      return UnitInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitInfo.Type.response.data.message
        ? UnitInfo.Type.response.data.message
        : "Error in UnitArr"
    );
    return [];
  }
};

const GetIncentiveGroup = async (xB_Itmcd, xA_Loc, SetIncentiveGroups) => {
  let vIncentiveGroupsObj = {
    itemCd: xB_Itmcd,
    loc: xA_Loc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vIncentiveGroupsObj);

  const vIncentiveGroups = await fExecuteAPI("INCENTIVEGROUP_GETROW", FinalObj);
  if (vIncentiveGroups.Type === "SUCCESS") {
    if (vIncentiveGroups.ResultSet.length > 0) {
      SetIncentiveGroups(vIncentiveGroups.ResultSet);
      return vIncentiveGroups.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      vIncentiveGroups.Type.response.data.message
        ? vIncentiveGroups.Type.response.data.message
        : "Error in vIncentiveGroups"
    );
    return [];
  }
};
const GetSupervisorSlabs = async (xsetSupervisorSlabs) => {
  const vSupervisorSlabs = await fExecuteAPI("SUPERVISORSLABS_GETROW");
  if (vSupervisorSlabs?.Type?.toUpperCase() === "SUCCESS") {
    xsetSupervisorSlabs(vSupervisorSlabs.ResultSet);
    return vSupervisorSlabs.ResultSet;
  } else {
    fAlertToast("FAILED", vSupervisorSlabs.Message);
    return [];
  }
};

const GetOtherSlabs = async (setOtherSlabs) => {
  const vOtherSlabs = await fExecuteAPI("OTHERSLABS_GETROW");
  if (vOtherSlabs?.Type?.toUpperCase() === "SUCCESS") {
    setOtherSlabs(vOtherSlabs.ResultSet);
    return vOtherSlabs.ResultSet;
  } else {
    fAlertToast("FAILED", vOtherSlabs.Message);
    return [];
  }
};

//API  ITEM_LINE_GETROW
const GetItemLineArr = async (xItemCode, xLoc, xParty, setItemLine) => {
  let vItemLineObj = {
    v_ItemCd: xItemCode,
    v_Loc: xLoc,
    v_Vendor: xParty,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemLineObj);

  const ItemLineInfo = await fExecuteAPI("ITEM_LINE_GETROW", FinalObj);
  if (ItemLineInfo.Status === 200) {
    if (ItemLineInfo.ResultSet.length > 0) {
      setItemLine(ItemLineInfo.ResultSet);
      return ItemLineInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      ItemLineInfo.Type.response.data.message
        ? ItemLineInfo.Type.response.data.message
        : "Error in ItemLineArr"
    );
    return [];
  }
};

//API  UNIT_RATE_GETROW
const GetUnitRateArr = async (
  xItmCd,
  xUnitId,
  xParty,
  xLoc,
  xVocTyp,
  xVocNo
) => {
  let vUnitRateObj = {
    ItmCd: xItmCd,
    UnitId: xUnitId,
    Party: xParty,
    Loc: xLoc,
    VocTyp: xVocTyp,
    VocNo: xVocNo,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vUnitRateObj);

  const UnitRateInfo = await fExecuteAPI("INBOUNDUNITRATE_GETROW", FinalObj);
  if (UnitRateInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitRateInfo.ResultSet.length > 0) {
      return UnitRateInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitRateInfo.Type.response.data.message
        ? UnitRateInfo.Type.response.data.message
        : "Error in UnitRateArr"
    );
    return [];
  }
};

export const GetUnitRate = async (
  xItmCd,
  xUnitId,
  xParty,
  xLoc,
  xVocTyp,
  xVocNo
) => {
  let vUnitRateObj = {
    ItmCd: xItmCd,
    Unit: xUnitId,
    Party: xParty,
    Loc: xLoc,
  };
  const resp = await fUnitPriceOnChangeGRV(vUnitRateObj);
  if (resp?.status === 200) {
    if (!!resp.data.ResultSet) {
      return resp?.data?.ResultSet;
    } else {
      return [];
    }
  }
};
//API
const GetItemFullSearchArr = async (xItemName, xLoc) => {
  // let vItemFullSearchDataObj = {
  //   v_AnyData: xItemName,
  //   v_TransType: "F",
  //   v_Report: "Y",
  // };
  let vItemFullSearchDataObj = {
    anyData: xItemName,
    transType: "F",
    report: "Y",
    loc: xLoc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemFullSearchDataObj);

  const vItemSearchFull = await fExecuteAPI(
    // "ITEM_SEARCHFULL_GETROW",
    "SEARCHEXACTITEM_GETROW",
    FinalObj
  );
  //status code "" so Success is checked
  if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
    if (vItemSearchFull.ResultSet.length > 0) {
      return vItemSearchFull.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      vItemSearchFull.Type.response.data.message
        ? vItemSearchFull.Type.response.data.message
        : "Error in vItemSearchFullArr"
    );
    return [];
  }
};

//API GETSIDETAILS_GETROW
const GetSIDetail = async (xB_VocNo, xB_Srno, xVocTyp) => {
  let iSIDetailObj = {
    v_TrnTyp: sTrnTyp,
    v_VocTyp: !!xVocTyp ? xVocTyp : "",
    v_VocNo: !!xB_VocNo ? xB_VocNo : "",
    v_SrNo: xB_Srno,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(iSIDetailObj);

  const resp = await inv04_INV04_LoadDetail_GETROW(FinalObj);
  if (resp?.status === 200) {
    if (resp.data.ResultSet?.length > 0) {
      return resp?.data?.ResultSet;
    } else {
      return [];
    }
  }
};

//API SaveSIHead

//API GETSIHEAD_GETROW to gethead
const fDisplay = async (xA_VocTyp, A_VocNo, dispatch, fNewDetail, setBuyer) => {
  const { HeadObject } = GRVRo();
  let vSIHeadObj = {
    v_A_VocTyp: xA_VocTyp || "",
    v_A_VocNo: A_VocNo || "",
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSIHeadObj);
  const resp = await inv04_fINV04_fDisplay_GETROW(FinalObj);
  if (resp?.status === 200) {
    dispatch(
      Set_GRV_HeadObject_Set({
        ...HeadObject,
        A_VocTyp: resp?.data?.ResultSet[0].A_VocTyp,
        A_VocTypName: resp?.data?.ResultSet[0].VocName,
        A_VocNo: resp?.data?.ResultSet[0].A_VocNo,
        A_PostDt: resp?.data?.ResultSet[0].A_PostDt,
        A_RefDt: resp?.data?.ResultSet[0].A_RefDt,
        A_RefNo: resp?.data?.ResultSet[0].A_RefNo,
        A_Party: resp?.data?.ResultSet[0].A_Party,
        A_PartyName: resp?.data?.ResultSet[0].PartyName,
        A_Curr: resp?.data?.ResultSet[0].A_Curr,
        A_Currname: resp?.data?.ResultSet[0].CurrName,
        A_ExRate: resp?.data?.ResultSet[0].A_ExRate,
        A_PayMode: resp?.data?.ResultSet[0].A_PayMode,
        A_Type: resp?.data?.ResultSet[0].A_Type,
        A_Loc: resp?.data?.ResultSet[0].A_Loc,
        A_Buyer: resp?.data?.ResultSet[0].A_Buyer, ////SalesMan
        A_Narr: resp?.data?.ResultSet[0].A_Narr,
        A_CrAc: resp?.data?.ResultSet[0].A_CrAc,
        A_CrAcName: resp?.data?.ResultSet[0].CrAcName,
        A_DrAc: resp?.data?.ResultSet[0].A_DrAc,
        A_DrAcName: resp?.data?.ResultSet[0].DrAcName,
        A_DiscPerc: resp?.data?.ResultSet[0].A_DiscPerc
          ? resp?.data?.ResultSet[0].A_DiscPerc
          : 0,
        A_Rounding: resp?.data?.ResultSet[0].A_Rounding
          ? resp?.data?.ResultSet[0].A_Rounding
          : 0,
        A_DocStat: resp?.data?.ResultSet[0].A_DocStat,
        TaxType: resp?.data?.ResultSet[0].A_CUSTFIELD3,
        A_TaxGross: !!resp?.data?.ResultSet[0].A_TaxGross
          ? resp?.data?.ResultSet[0].A_TaxGross
          : "N",
        A_Taxable: !!resp?.data?.ResultSet[0].A_Taxable
          ? resp?.data?.ResultSet[0].A_Taxable
          : "N",
        A_Br: resp?.data?.ResultSet[0].A_Br,
        A_DiscAmt: resp?.data?.ResultSet[0].A_DiscAmt, //decimal
        offer: !!resp?.data?.ResultSet[0].A_CUSTFIELD5
          ? resp?.data?.ResultSet[0].A_CUSTFIELD5
          : "N", // Offer Y/N
        DO: !!resp?.data?.ResultSet[0].A_CUSTFIELD9
          ? resp?.data?.ResultSet[0].A_CUSTFIELD9
          : "N",
        CostRecalculate: !!resp?.data?.ResultSet[0]?.isCostRecalculate
          ? resp?.data?.ResultSet[0]?.isCostRecalculate
          : "N",
        BatchType: resp?.data?.ResultSet[0]?.A_CUSTFIELD8,
        A_VATRefNo: resp?.data?.ResultSet[0]?.A_VATRefNo,
      })
    );
    // ItemsAliasListSearch( resp?.data?.ResultSet[0].A_Loc, sBufferObj.B_Itmcd);

    fNewDetail(
      resp?.data?.ResultSet[0].A_VocNo,
      resp?.data?.ResultSet[0].A_Rounding,
      resp?.data?.ResultSet[0].A_VocTyp,
      resp?.data?.ResultSet[0].A_CUSTFIELD3
    );
  }
};

//API  "PoQtyValidation_GETROW",
const GetPoQtyValidation = async (dispatch, sBufferObj) => {
  const { HeadObject } = GRVRo();

  let vPoQtyValidationObj = {
    PoTyp: "", // HeadObject.A_RefDocTyp,
    PoNo: "", //HeadObject.A_RefDocNo,
    GrnType: HeadObject.A_VocTyp,
    GrnNo: HeadObject.A_VocNo,
    SrNo: sBufferObj.B_Srno,
    ItmCd: sBufferObj.B_Itmcd,
    Qty: sBufferObj.B_Qty,
    Unit: sBufferObj.B_Unit,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vPoQtyValidationObj);

  const vPoQtyValidation = await fExecuteAPI(
    "PoQtyValidation_GETROW",
    FinalObj
  );
  if (vPoQtyValidation?.Type?.toUpperCase() === "SUCCESS") {
    return vPoQtyValidation.ResultSet;
  } else {
    fAlertToast("FAILED", vPoQtyValidation?.response?.data?.Status);
    return [];
  }
};

//API  "TsrQtyValidation_GETROW",
const GetTsrQtyValidation = async (dispatch, sBufferObj) => {
  const { HeadObject } = GRVRo();

  let vTsrQtyValidationObj = {
    PoTyp: "", //HeadObject.A_RefDocTyp,
    PoNo: "", //HeadObject.A_RefDocNo,
    GrnType: HeadObject.A_VocTyp,
    GrnNo: HeadObject.A_VocNo,
    SrNo: sBufferObj.B_Srno,
    ItmCd: sBufferObj.B_Itmcd,
    Qty: sBufferObj.B_Qty,
    Unit: sBufferObj.B_Unit,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vTsrQtyValidationObj);

  const vTsrQtyValidation = await fExecuteAPI(
    "TsrQtyValidation_GETROW",
    FinalObj
  );

  if (vTsrQtyValidation?.Type?.toUpperCase() === "SUCCESS") {
    return vTsrQtyValidation.ResultSet;
  } else {
    fAlertToast("FAILED", vTsrQtyValidation?.response?.data?.Status);
    return [];
  }
};

//API  "GrnRefNoValidation_GETROW",
const GrnRefNoValidation = async (dispatch) => {
  const { HeadObject } = GRVRo();
  let vGrnRefNoValidationObj = {
    TrnTyp: sTrnTyp,
    RefNo: "", // HeadObject.A_RefDocNo,
    Vendor: HeadObject.A_Party,
    VocTyp: HeadObject.A_VocTyp,
    VocNo: HeadObject.A_VocNo,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vGrnRefNoValidationObj);
  const vGrnRefNoValidation = await fExecuteAPI(
    "GrnRefNoValidation_GETROW",
    FinalObj
  );
  if (vGrnRefNoValidation?.Type?.toUpperCase() === "SUCCESS") {
    return vGrnRefNoValidation.ResultSet ? vGrnRefNoValidation.ResultSet : [];
  } else {
    fAlertToast("FAILED", vGrnRefNoValidation?.response?.data?.Status);
    return [];
  }
};

//API TransTaxType_GETROW
const GetTransTaxType = async (xLoc, xParty, dispatch) => {
  let vTransTaxTypeObj = {
    loc: xLoc,
    party: xParty,
    taxtype: "IN",
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vTransTaxTypeObj);
  const vTransTaxType = await fExecuteAPI("TransTaxType_GETROW", FinalObj);
  if (vTransTaxType?.Type?.toUpperCase() === "SUCCESS") {
    if (vTransTaxType.ResultSet.length > 0) {
      return vTransTaxType.ResultSet[0];
    } else {
      fAlertToast("FAILED", "Default tax object is empty");
      return {};
    }
  } else {
    fAlertToast("FAILED", vTransTaxType?.response?.data?.Status);
    return {};
  }
};

const Get_ToggleDropDown_Load = async (
  xData,
  xType,
  xAcTyp,
  xExact,
  dispatch
) => {
  const { HeadObject } = GRVRo();
  let vLoaded_Cost_FreightObj = {
    Data: xData,
    Type: xType,
    Loc: HeadObject.A_Loc,
    AcTyp: xAcTyp,
    Exact: xExact,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vLoaded_Cost_FreightObj);
  const vLandedCostDropdownSearch = await fExecuteAPI(
    "AccountTransSearch_GETROW",
    FinalObj
  );
  if (vLandedCostDropdownSearch?.Type?.toUpperCase() === "SUCCESS") {
    let GridID = [];
    if (vLandedCostDropdownSearch.ResultSet.length > 0) {
      let GridID = vLandedCostDropdownSearch.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      return GridID;
    } else {
      return GridID;
    }
  } else {
    fAlertToast("FAILED", "Error in loading LandedCost Api");
    return [];
  }
};

//API CHECK_PO_CREDIT_NOTE_AMOUNT_GETROW
const GetCheckPOCreditNoteAmount = async (dispatch) => {
  const { HeadObject } = GRVRo();
  let vCheckPOCreditNoteAmountObj = {
    VocTyp: HeadObject?.A_VocTyp,
    VocNo: HeadObject?.A_VocNo,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(
    vCheckPOCreditNoteAmountObj
  );

  const vCheckPOCreditNoteAmount = await fExecuteAPI(
    "CHECK_PO_CREDIT_NOTE_AMOUNT_GETROW",
    FinalObj
  );
  if (vCheckPOCreditNoteAmount?.Type?.toUpperCase() === "SUCCESS") {
    return vCheckPOCreditNoteAmount.ResultSet.length > 0
      ? vCheckPOCreditNoteAmount.ResultSet
      : [];
  } else if (vCheckPOCreditNoteAmount.response.status == 400) {
    fAlertToast("FAILED", vCheckPOCreditNoteAmount.response.data.Status);
    return [];
  } else if (vCheckPOCreditNoteAmount.response.status == 500) {
    fAlertToast("FAILED", vCheckPOCreditNoteAmount.response.data.Status);
    return [];
  }
};

//API VALIDATE_COST_VARIANCE_GETROW
const GetValidateCostVariance = async (dispatch) => {
  const { HeadObject } = GRVRo();
  const vRdxUserInfoObj = vRdxUserInfo();
  // let vValidateCostVarianceObj = {
  //   voctyp: "WG002",
  //   vocno: "GRSDC00211",
  //   usercd: "001",
  // };
  let vValidateCostVarianceObj = {
    voctyp: HeadObject?.A_VocTyp,
    vocno: HeadObject?.A_VocNo,
    usercd: vRdxUserInfoObj?.UserID,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vValidateCostVarianceObj);

  const vValidateCostVariance = await fExecuteAPI(
    "VALIDATE_COST_VARIANCE_GETROW",
    FinalObj
  );
  if (vValidateCostVariance?.Type?.toUpperCase() === "SUCCESS") {
    return vValidateCostVariance.ResultSet.length > 0
      ? vValidateCostVariance.ResultSet
      : [];
  } else if (vValidateCostVariance.response.status == 400) {
    fAlertToast("FAILED", vValidateCostVariance.response.data.Status);
    return [];
  } else if (vValidateCostVariance.response.status == 500) {
    fAlertToast("FAILED", vValidateCostVariance.response.data.Status);
    return [];
  }
};

//API SALESGROUP
const GetSalesGroups = async (xA_Loc) => {
  const vSalesGroups = await fExecuteAPI("SALESGROUPS_GETROW", xA_Loc);
  if (vSalesGroups.Type == "SUCCESS") {
    return vSalesGroups.ResultSet;
  } else {
    fAlertToast("FAILED", vSalesGroups.Message);
    return [];
  }
};

var vheaderArrow = 0;
const fRightClick = (e) => {
  vheaderArrow !== 1 ? (vheaderArrow = vheaderArrow + 1) : (vheaderArrow = 1);

  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};

const fLeftClick = (e) => {
  vheaderArrow !== 0 ? (vheaderArrow = vheaderArrow - 1) : (vheaderArrow = 0);
  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};

//defcustomersetting_GETROW
const GetDefcustomersetting = async (xAcCd, xLoc, xOutboundType, dispatch) => {
  const { HeadObject } = GRVRo();
  let vdefcustomersettingObj = {
    accd: xAcCd,
    loc: xLoc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vdefcustomersettingObj);

  const vdefcustomersetting = await fExecuteAPI(
    "defcustomersetting_GETROW",
    FinalObj
  );
  if (vdefcustomersetting.Type == "SUCCESS") {
    if (
      vdefcustomersetting.ResultSet.length > 0 &&
      !!vdefcustomersetting.ResultSet[0].SalesMan
    ) {
      dispatch(
        Wms_HeadObject_Buyer_Set({
          A_Buyer: !!vdefcustomersetting.ResultSet[0].SalesMan
            ? vdefcustomersetting.ResultSet[0].SalesMan
            : HeadObject.A_Buyer,
        })
      );
    }
  } else {
    fAlertToast(
      "FAILED",
      !!vdefcustomersetting.Message
        ? vdefcustomersetting.Message
        : "Error in default setting customer"
    );
  }
};

export const xGCSearchBtn_Columns_DropdownSearch = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "AcCd", headerName: "Code", width: 100 },
  { field: "Name2", headerName: "Name2", width: 450 },
  // { field: "Name1", headerName: "Name1", width: 220 },
];
const Get_GCSearchBtn = async (xData, xType, xExact = "N") => {
  const vRdxUserInfoObj = vRdxUserInfo();
  let vLoaded_Cost_FreightObj = {
    v_Data: xData,
    v_Type: xType,
    v_TrnTyp: sTrnTyp,
    v_UserId: vRdxUserInfoObj.UserID,
    Exact: xExact,
  };
  const vLandedCostDropdownSearch = await fExecuteAPI(
    "Common_transpartylist_GETROW",
    vLoaded_Cost_FreightObj
  );
  if (vLandedCostDropdownSearch.Type?.toUpperCase() === "SUCCESS") {
    let GridID = [];
    if (vLandedCostDropdownSearch.ResultSet.length > 0) {
      let GridID = vLandedCostDropdownSearch.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      return GridID;
    } else {
      return GridID;
    }
  } else {
    fAlertToast("FAILED", "Error in loading LandedCost Api");
    return [];
  }
};
const GetOSAmount = async (xLoc, xParty, setOsAmount) => {
  const { HeadObject } = GRVRo();
  let vOsAmtObj = {
    loc: xLoc,
    unit: xParty,
  };
  if (HeadObject.A_DocStat === "ENTER") {
    const vOsAmt = await fExecuteAPI("Common_partyosamtt_GETROW", vOsAmtObj);
    if (
      vOsAmt?.Type?.toUpperCase() === "SUCCESS" &&
      vOsAmt?.ResultSet?.length > 0
    ) {
      setOsAmount((obj) => ({
        ...obj,
        NetOsAmt: vOsAmt.ResultSet[0].NetAmtWithoutPDC,
        PDCAmt: vOsAmt.ResultSet[0].PDCAmt,
        BalanceOsAmt: vOsAmt.ResultSet[0].NetAmtAfterPDC,
      }));
    } else {
      fAlertToast(
        "FAILED",
        vOsAmt.response.data.message || vOsAmt.response.data.Status
      );
    }
  } else {
    setOsAmount((obj) => ({
      ...obj,
      NetOsAmt: 0,
      PDCAmt: 0,
      BalanceOsAmt: 0,
    }));
  }
};

export const GetAttributes = async (
  setObjectRights,
  setUser_Doc_Arr,
  setDocLoading,
  setCurrency,
  setReason,
  setPaymode,
  setTax,
  setLoc
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var vObj = {
    userCode: vRdxUserInfoObj.UserID,
    userGroupCode: vRdxUserInfoObj.UserGroupCode,
  };
  const iAttributes = await inv04_fINV04_Attributes_GETROW(vObj);

  console.log(iAttributes);

  if (iAttributes?.status === 200) {
    setUser_Doc_Arr(iAttributes?.data?.ResultSet?.UserDoc);
    setObjectRights(iAttributes?.data?.ResultSet?.Rights);
    setDocLoading(iAttributes?.data?.ResultSet?.DocLoading);
    setReason(iAttributes?.data?.ResultSet?.Reason);
    setPaymode(iAttributes?.data?.ResultSet?.Paymode);
    setTax(iAttributes?.data?.ResultSet?.TaxType);
    setLoc(iAttributes?.data?.ResultSet?.Loc);
    setCurrency(iAttributes?.data?.ResultSet?.Currency);
    return iAttributes?.data?.ResultSet;
  } else {
    return [];
  }
};
export const getTransItemStockUOM = async (
  setTransItemStockObj,
  xB_Itmcd,
  xB_Unit,
  xLoc
) => {
  let ApiObj = await Get_TransItemStockUOM(xB_Itmcd, xB_Unit, xLoc);
  if (ApiObj?.length > 0) {
    setTransItemStockObj({
      RPStock: ApiObj[0]?.RPStock,
      MSP: ApiObj[0].MSP,
      CostPr: ApiObj[0].CostPr,
      LPRate: ApiObj[0].LPRate,
    });
  }
};

export {
  // rows,
  // columns,
  GetOSAmount,
  Get_GCSearchBtn,
  fRightClick,
  fLeftClick,
  // sTax,
  sFocFlagArr,
  fKeyGRV,
  fKeyGRVContent,
  // Api
  GetCheckboxUserRights,
  GetBuyer,
  GetSalesman,
  GetDefaultDrCrAccount,
  GetLocation,
  GetUnitArr,
  GetItemLineArr,
  GetUnitRateArr,
  GetIncentiveGroup,
  GetItemFullSearchArr,
  GetItemSearch,
  fItemCodeDependency,
  Unit_Onchange_001,
  GetSearchItem,
  GetTransTaxType,
  GrnRefNoValidation,
  GetPoQtyValidation,
  GetTsrQtyValidation,
  GetSalesGroups,
  GetOtherSlabs,
  GetSupervisorSlabs,
  //save
  fValidationHead_Client,
  fValidationDetail_Client,
  fLoad_Grid,
  fDisplay,

  //reverse
  fCloseReverseTransactionModal,
  fOpenReverseTransactionModal,
  fReverse,

  //Head functions
  fDefaultPayload,

  //Approve
  GetCheckPOCreditNoteAmount,
  GetValidateCostVariance,

  //src doc
  Get_ToggleDropDown_Load,
  //GCLoadedCost
  GetDefcustomersetting,

  //grid history
  GetSalesHistory,
};
